import React, { useEffect, useState } from "react";
import axios from "axios";
import "./add.css";
import { useNavigate } from "react-router-dom";
import AdminLayout from "./AdminLayout";

const AddProperty = () => {
  const navigate = useNavigate();

  const initialState = {
    title: "",
    price: "",
    transactionType: "sale",
    productType: "appartement",
    propertyCategory: "residential",
    status: "available",
    coduStatus: "codu",
    address: "",
    city: "",
    coordinates: {
      latitude: "",
      longitude: "",
    },
    features: {
      bedrooms: 0,
      bathrooms: 0,
      parkingSpaces: 0,
      garages: 0,
      area: 0,
      hasPool: false,
      isWheelchairAccessible: false,
      isWaterfront: false,
      hasNavigableWater: false,
      allowsPets: false,
      allowsSmoking: false,
    },
    images: [],
    buildingDetails: {
      yearBuilt: "",
      isNewConstruction: false,
      isHistorical: false,
      structureType: [],
    },
    isVirtualTourAvailable: false,
    isOpenHouse: false,
    lotSize: 0,
    description: "",
    // agentName: "",
    moveInDate: "",
    isForeclosure: false,
    agent: "",
  };

  const [formData, setFormData] = useState(initialState);
  const [agents, setAgents] = useState([]);
  const [loading, setLoading] = useState(true);  // Nouvelle variable pour gérer le chargement
  const [errorMessage, setErrorMessage] = useState("");

  

  // 🔹 Gestion des champs standards
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleAgentChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      agentId: e.target.value,
    }));
  };
  // 🔹 Gestion des coordonnées (conversion en Number)
  const handleCoordinatesChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      coordinates: {
        ...prevState.coordinates,
        [name]: value ? parseFloat(value) : "",
      },
    }));
  };

  // 🔹 Gestion des champs imbriqués (conversion en Number)
  const handleNestedChange = (e, section) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [section]: {
        ...prevState[section],
        [name]: value ? parseInt(value, 10) : 0,
      },
    }));
  };

  // 🔹 Gestion des images
  const handleImageChange = (e, index) => {
    const newImages = [...formData.images];
    newImages[index] = e.target.value;
    setFormData((prevState) => ({
      ...prevState,
      images: newImages,
    }));
  };

  const handleAddImage = () => {
    setFormData((prevState) => ({
      ...prevState,
      images: [...prevState.images, ""],
    }));
  };

  const handleRemoveImage = (index) => {
    const newImages = [...formData.images];
    newImages.splice(index, 1);
    setFormData((prevState) => ({
      ...prevState,
      images: newImages,
    }));
  };

  // 🔹 Validation du formulaire
 

  // 🔹 Soumission du formulaire
// 🔹 Soumission du formulaire
const handleSubmit = async (e) => {
  e.preventDefault();
  console.log("Payload envoyé :", formData);

  try {
    await axios.post(
      "https://keurgui-backend-kjour.ondigitalocean.app/api/products/create-with-agent",
      formData,
      { headers: { "Content-Type": "application/json" } }
    );
    alert("Produit ajouté avec succès !");
    setFormData(initialState);
    
    // Rediriger vers /admin après succès
    navigate("/admin");
  } catch (error) {
    console.error(
      "Erreur lors de l'ajout du produit :",
      error.response?.data || error.message
    );
    alert(
      `Échec de l'ajout du produit : ${
        error.response?.data?.message || error.message
      }`
    );
  }
};

  useEffect(() => {
    const fetchAgents = async () => {
      try {
        const response = await axios.get("https://keurgui-backend-kjour.ondigitalocean.app/agents");
        setAgents(response.data);  // Stocke la liste des agents
        setLoading(false);  // Drapeau de fin de chargement
      } catch (error) {
        console.error("Erreur lors de la récupération des agents :", error);
        setLoading(false);  // En cas d'erreur, arrêter le chargement
      }
    };

    fetchAgents();
  }, []);
 const handleLocalUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) return;

  const formDataFile = new FormData();
  formDataFile.append("image", file);

  try {
    // Ton endpoint backend reste le même, mais ton backend doit uploader sur DigitalOcean
    const res = await axios.post("https://keurgui-backend-kjour.ondigitalocean.app/api/upload", formDataFile, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    // DigitalOcean Space renvoie l'URL publique de l'image
    const imageUrl = res.data.imageUrl;

    setFormData((prev) => ({
      ...prev,
      images: [...prev.images, imageUrl], // ici on stocke l'URL publique directement
    }));
  } catch (err) {
    console.error("Erreur d’upload :", err);
    alert("Upload échoué");
  }
};
  return (
    <AdminLayout>
    <div className="add-property-container">
      <h2>Ajouter une propriété</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Titre :</label>
          <input
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Prix :</label>
          <input
            type="number"
            name="price"
            value={formData.price}
            onChange={handleChange}
            required
          />
        </div>
        <div>
          <label>Type de transaction :</label>
          <select
            name="transactionType"
            value={formData.transactionType}
            onChange={handleChange}
            required
          >
            <option value="sale">À vendre</option>
            <option value="rent">À louer</option>
          </select>
        </div>
        <div>
  <label>Type de produit :</label>
  <select
    name="productType"
    value={formData.productType}
    onChange={handleChange}
    required
  >
    <option value="appartement">Appartement</option>
    <option value="bureau_commerce">Bureau / Commerce</option>
    <option value="hotel_restaurant">Hôtel / Restaurant</option>
    <option value="immeuble">Immeuble</option>
    <option value="residence">Résidence</option>
    <option value="studio_chambre">Studio / Chambre</option>
    <option value="villa_maison">Villa / Maison</option>
    <option value="terrain">Terrain</option>
  </select>
</div>
<div>
  <label>Statut CODOU :</label>
  <select
    name="coduStatus"
    value={formData.coduStatus}
    onChange={handleChange}
    required
  >
    <option value="codu">CODU</option>
    <option value="noncodu">Non CODU</option>
  </select>
</div>

        <div>
          <label>Latitude :</label>
          <input
            type="number"
            step="any"
            name="latitude"
            value={formData.coordinates.latitude}
            onChange={handleCoordinatesChange}
            placeholder="Exemple : -14.69278"
            required
          />
        </div>
        <div>
          <label>Longitude :</label>
          <input
            type="number"
            step="any"
            name="longitude"
            value={formData.coordinates.longitude}
            onChange={handleCoordinatesChange}
            placeholder="Exemple : 17.44639"
            required
          />
        </div>
        <div>
          <label>Adresse :</label>
          <select
            name="address"
            value={formData.address}
            onChange={handleChange}
            required
          >
            <option value="">Sélectionnez une adresse</option>
            <option value="Dakar/Dakar(Gueule tapee fass colobane)">Dakar/Dakar (Gueule tapee fass colobane)</option>
  <option value="Dakar/Dakar(Fann point e amitie)">Dakar/Dakar (Fann point e amitie)</option>
  <option value="Dakar/Dakar(Goree)">Dakar/Dakar (Goree)</option>
  <option value="Dakar/Dakar(Medina)">Dakar/Dakar (Medina)</option>
  <option value="Dakar/Dakar(Plateau)">Dakar/Dakar (Plateau)</option>
  <option value="Dakar/Dakar(Camberene)">Dakar/Dakar (Camberene)</option>
          </select>
        </div>
        <div>
          <label>Ville :</label>
          <select
            name="city"
            value={formData.city}
            onChange={handleChange}
            required
          >
            <option value="">Sélectionnez une région</option>
    <option value="Dakar">Dakar</option>
    <option value="Diourbel">Diourbel</option>
    <option value="Fatick">Fatick</option>
    <option value="Kaffrine">Kaffrine</option>
    <option value="Kaolack">Kaolack</option>
    <option value="Kédougou">Kédougou</option>
    <option value="Kolda">Kolda</option>
    <option value="Louga">Louga</option>
    <option value="Matam">Matam</option>
    <option value="Saint-Louis">Saint-Louis</option>
    <option value="Sédhiou">Sédhiou</option>
    <option value="Tambacounda">Tambacounda</option>
    <option value="Thiès">Thiès</option>
    <option value="Ziguinchor">Ziguinchor</option>
          </select>
        </div>
        <div>
          <label>Nombre de chambres :</label>
          <input
            type="number"
            name="bedrooms"
            value={formData.features.bedrooms}
            onChange={(e) => handleNestedChange(e, "features")}
            required
          />
        </div>
        <div>
          <label>Nombre de salles de bain :</label>
          <input
            type="number"
            name="bathrooms"
            value={formData.features.bathrooms}
            onChange={(e) => handleNestedChange(e, "features")}
            required
          />
        </div>
        <div>
  <label>Ajouter une image :</label>
  <input type="file" accept="image/*" onChange={handleLocalUpload} />
 {formData.images
  .filter((imgUrl) => imgUrl) // ne garde que les non vides
  .map((imgUrl, index) => (
    <div key={index}>
      <img src={imgUrl} alt={`img-${index}`} width={100} />
      <button type="button" onClick={() => handleRemoveImage(index)}>Supprimer</button>
    </div>
  ))}
</div>

        <div>
          <label>Description :</label>
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Agent :</label>
          {loading ? (
            <p>Chargement des agents...</p>
          ) : (
            <select
  name="agent"
  value={formData.agent}
  onChange={handleChange}
  required
>
  <option value="">Sélectionnez un agent</option>
  {agents.map((agent) => (
    <option key={agent._id} value={agent._id}>
      {agent.agentName}
    </option>
  ))}
</select>

          )}
        </div>
        <div>
          <label>Date d'emménagement :</label>
          <input
            type="date"
            name="moveInDate"
            value={formData.moveInDate}
            onChange={handleChange}
          />
        </div>
        <button type="submit">Ajouter</button>
      </form>
    </div>
    </AdminLayout>
  );
};

export default AddProperty;
